import React from 'react';
import CustomTooltip from './CustomTooltip';

/**
 * A reusable soft skill pill component that displays a soft skill with a tooltip
 * 
 * @param {Object} props - Component props
 * @param {string} props.name - The name of the skill
 * @param {string} props.title - Optional tooltip text to display on hover
 * @param {Array} props.context - Optional array of context strings to display as bullet points
 * @param {string} props.className - Optional additional CSS classes
 * @returns {JSX.Element} - The rendered component
 */
const SoftSkillPill = ({ name, title, context, className = '' }) => {
  const content = (
    <span className={`bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm cursor-help ${className}`}>
      {name}
    </span>
  );
  
  const hasTooltipContent = title || (context && context.length > 0);
  
  const tooltipContent = hasTooltipContent
    ? <div>
        {title}
        {context && context.length > 0 && (
          <div className="mt-2">
            <ul className="list-disc list-inside space-y-1 text-sm">
              {context.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    : null;
  
  return tooltipContent ? (
    <CustomTooltip content={tooltipContent} className="text-lg">
      {content}
    </CustomTooltip>
  ) : content;
};

export default SoftSkillPill;
